<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
                <template slot="menuLeft">
                    <el-button type="text" icon="el-icon-download" size="small" plain
                        @click.stop="downloadExcel">下载Excel</el-button>
                    <el-button type="text" icon="el-icon-download" size="small" plain
                        @click.stop=downloadCode>下载售后报单通用码</el-button>
                </template>
                <!-- <template slot-scope="scope" slot="menu">
                    <el-button type="text" icon="el-icon-view" size="small" plain
                        @click.stop="toViewOrder(scope.row.id, scope.row)">工单</el-button>
                </template> -->
                <template slot-scope="scope" slot="menuBtn">
                    <el-button type="text" icon="el-icon-view" size="small" plain
                        @click.stop="toViewOrder(scope.row.id, scope.row)">工单</el-button>
                    <el-button type="text" icon="el-icon-edit" size="small" plain
                        v-if="permission.JOINS_SALES_CLOUD_EDIT_MERCHANTS && scope.row.status !== 'TO_BE_THE_FINAL' && scope.row.status !== 'SOLVE' && scope.row.status !== 'COMPLETE' && scope.row.status !== 'TO_EVALUATE' && scope.row.status !== 'TO_BE_EVALUATED'"
                        @click.stop="afterSaslesEdit(scope.row, scope.$index)">修改
                    </el-button>
                    <el-button v-if="scope.row.status == 'SOLVE' || scope.row.status == 'COMPLETE'" type="text"
                        icon="el-icon-view" size="small" plain
                        @click.stop="evaluateInfoView(scope.row.id, scope.row.type)">评价</el-button>
                    <el-button type="text" icon="el-icon-check" size="small" plain @click.stop="openPay(scope.row)"
                        v-if="scope.row.status == 'WAIT_PAY'">立即付款</el-button>
                    <!-- 审核 -->
                    <el-button type="text" icon="el-icon-check" size="small" plain
                        @click.stop="handleStatusAudit(scope.row, scope.$index)"
                        v-if="scope.row.status == 'TO_BE_THE_FINAL'">通过</el-button>
                    <el-button type="text" icon="el-icon-close" size="small" plain
                        @click.stop="handleStatusRefuse(scope.row, scope.$index)"
                        v-if="scope.row.status == 'TO_BE_THE_FINAL'">拒绝</el-button>
                    <!-- 作废：工单作废功能，需要用户确认是否作废 -->
                    <el-button type="text" icon="el-icon-delete" size="small" plain
                        
                        @click.stop="handleCancelOrder(scope.row, scope.$index)">作废
                    </el-button>
                </template>
                <template slot-scope="scope" slot="videoUrl">
                    <el-button type="text" @click="viewVideo(scope.row.videoUrl)"
                        v-if="scope.row.videoUrl">查看视频</el-button>
                </template>
                <template slot-scope="scope" slot="faultPhotosForm">
                    <span v-if="!scope.row.faultPhotos">无</span>
                    <viewer :images="formmaterImage(scope.row.faultPhotos)">
                        <img v-for="src in formmaterImage(scope.row.faultPhotos)" :src="src" :key="src" width="20" />
                    </viewer>
                </template>
                <template slot-scope="scope" slot="deliveryUrl">
                    <viewer :images="formmaterImage(scope.row.deliveryUrl)">
                        <img v-for="src in formmaterImage(scope.row.deliveryUrl)" :src="src" :key="src" width="20" />
                    </viewer>
                </template>
                <template slot-scope="scope" slot="videoUrlForm">
                    <span v-if="!scope.row.videoUrl">无</span>
                    <el-button type="text" @click="viewVideo(scope.row.videoUrl)"
                        v-if="scope.row.videoUrl">查看视频</el-button>
                </template>
                <template slot-scope="scope" slot="status">
                    <div v-for="obj of preFilterStatus" :key="obj.value">
                        <el-tag v-if="obj.value == scope.row.status">
                            {{ obj.label }}</el-tag>
                    </div>
                </template>
                <template slot-scope="scope" slot="faultPhotos">
                    <viewer :images="formmaterImage(scope.row.faultPhotos)">
                        <img v-for="src in formmaterImage(scope.row.faultPhotos)" :src="src" :key="src" width="20">
                    </viewer>
                </template>
            </avue-crud>
            <!-- 选择工程师弹窗 -->
            <el-dialog title="查看视频" :visible.sync="dialogVisibleVideo" width="50%">
                <video :src="nowVideoUrl" controls="controls" width="100%" height="500px"></video>
            </el-dialog>
            <!-- 编辑弹窗 -->
            <el-dialog title="编辑" :visible.sync="dialogVisibleAfterSales" width="50%">
                <el-form ref="form" :model="rowData" label-width="100px">
                    <el-form-item label="产品" prop="goodsId" v-if="isShowGoods">
                        <el-select v-model="rowData.goodsId" placeholder="请选择产品" clearable filterable>
                            <el-option v-for="item in goodsList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工程师" prop="engineerId">
                        <el-select v-model="rowData.engineerName" placeholder="请选择工程师" filterable remote
                            :remote-method="handleRemote" clearable @change="handleEngineerChange">
                            <el-option v-for="item in users" :key="item.id" :label="item.realName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否提货" prop="delivery">
                        <el-radio-group v-model="rowData.delivery">
                            <el-radio :label="0">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否过保" prop="overinsuredFlag">
                        <el-radio-group v-model="rowData.overinsuredFlag">
                            <el-radio label="是">是</el-radio>
                            <el-radio label="否">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="前仓" prop="warehouseId" v-if="isShowGoods && rowData.delivery == 0">
                        <el-select v-model="rowData.warehouseId" placeholder="请选择前仓" clearable filterable>
                            <el-option v-for="item in warehouseList" :key="item.id" :label="item.warehouseName"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeVisibleAfterSales">取 消</el-button>
                    <el-button type="primary" @click="handleAfterSalesUpdate(rowData)">确 定
                    </el-button>
                </div>
            </el-dialog>
            <viewOrder :visibleOrder.sync="viewOrderVisible" :orderId="orderId" :orderType="orderType"
                :evaluateInfo="evaluateInfo" :declarationInfo="declarationInfo" />
        </basic-container>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { afterSalesOption } from "@/const/work/afterSalesOption/afterSalesOption";
import { getOrderStatusList } from "@/api/work/waterProof/merchants"
import { findpreAfterSalesOrder, downloadExcelPureWaterGoods, refund, findUserList, updateAfterSalesOrder, getAfterSalesOrder, getDownloadCode, getRootDepartmentId, cancelAfterSalesOrder } from "@/api/work/afterSales/afterSales";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { resolveUrlPath } from "@/util/util";
import { getWarehouseList } from "@/api/salesCloud/warehouse";
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import VueQr from "vue-qr";
import viewOrder from "./components/viewOrder.vue";
export default {
    name: "preFilter",
    components: {
        VueQr,
        viewOrder,
    },
    data() {
        return {
            tableOption: afterSalesOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            tabelObj: {},
            downloadData: {},
            isShowGoods: false,
            warehouseList: [],
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10, //每页显示多少条
            },
            grade: {
                box: false,
                check: [],
            },
            rootDepartmentId: "",
            dialogVisible: false,
            dialogVisibleVideo: false,
            dialogVisibleAfterSales: false,
            rowData: {},
            nowVideoUrl: "",
            users: [],
            user: "",
            detailData: [],
            selectRedPacket: {},
            detailSearch: {},
            detailPage: {
                total: 0,
                currentPage: 1,
                pageSize: 10,
            },
            orderType: "",
            //余额支付
            balancePayRadio: "YE",
            goodsList: [],
            serviceCategory: {},
            joinsWorkServiceItems: [],
            workOrderStatus: DIC.WORK_ORDER_STATUS,
            QRCodeDialog: false,
            config: {},
            noMoney: true,
            getBalance: 0,
            evaluateDialog: false,
            dialogBalancePay: false,
            viewOrderVisible: false,
            evaluateInfo: false,
            orderId: "",
            declarationId: "",
            declarationInfo: {},
            rechargeDialog: false,
            rechargeMoney: "",
            payRadio: "OFFLINE_REMIT",
            remittanceAccountName: "",
            remittanceAccount: "",
            currBank: "",
            remittanceBank: DIC.BANK_LIST,
            fileList1: [],
            remittanceImgs: [],
            brands: [],
            brand: {},
            classifies: [],
            classify: {},
            departments: [],
            department: {},
            secondClassifies: [],
            secondClassify: {},
            goods: {},
            preFilterStatus: [],
            // 状态列表
            orderStatusList: [],
        };
    },
    created() {
        this.handleList();
        this.getOrderStatus();
        this.handleWarehouseList();
    },
    watch: {},
    mounted() { },
    computed: {
        ...mapGetters(["permission"]),
    },
    props: [],
    methods: {
        // 获取订单状态列表
        async getOrderStatus() {
            try {
                const res = await getOrderStatusList('type=after_sales_engineering');
                if (res.code == "200") {
                    this.orderStatusList = JSON.parse(res.data);
                    // 将状态列表转换为下拉选项
                    this.orderStatusList = this.orderStatusList.map(item => ({
                        label: item.name,
                        value: item.code
                    }));
                    this.preFilterStatus = this.orderStatusList;
                    // 按 prop 精准定位列，更新 orderStatus 的 dicData
                    const idx = Array.isArray(this.tableOption.column)
                        ? this.tableOption.column.findIndex(col => col && col.prop === "status")
                        : -1;
                    if (idx !== -1) {
                        this.$set(this.tableOption.column[idx], "dicData", this.orderStatusList);
                    }
                    // 兼容老数据：TO_EVALUATE 是旧版待评价状态
                    const hasOldStatus = this.orderStatusList.some(item => item.value === 'TO_EVALUATE');
                    const newEvaluateStatus = this.orderStatusList.find(item => item.value === 'TO_BE_EVALUATED');
                    if (!hasOldStatus && newEvaluateStatus) {
                        this.orderStatusList.push({
                            label: newEvaluateStatus.label,
                            value: 'TO_EVALUATE'
                        });
                    }
                }
            } catch (error) {
                this.$message.error("获取订单状态失败");
            }
        },
        closeVisibleAfterSales() {
            this.dialogVisibleAfterSales = false;
            this.rowData = {};
            this.goods = {};
            this.engineer = {};
            this.isShowGoods = false;
        },
        handleCancelOrder(row) {
            this.$prompt('请输入作废原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: '请输入正确长度的作废原因1-255',
            }).then(({ value }) => {
                // 调用作废API
                let params = {
                    afterSaleId: row.id,
                    projectType: 'AFTER_SALES',
                    reason: value,
                    declarationId: '',
                };
                this.$message({
                    showClose: true,
                    message: "工单已成功作废",
                    type: "success",
                });
                cancelAfterSalesOrder(params).then((response) => {
                    if (response.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "工单已成功作废",
                            type: "success",
                        });
                        this.handleList(); // 刷新列表
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.message,
                            type: "error",
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消作废'
                });
            });
        },
        handleAfterSalesUpdate(row) {
            if (this.engineer && this.engineer.engineerId) {
                row.engineerId = this.engineer.engineerId;
                row.engineerMobile = this.engineer.engineerMobile;
                row.engineerName = this.engineer.engineerName;
            }
            // 表单验证
            if (!row.goodsId && this.isShowGoods) {
                this.$message({
                    showClose: true,
                    message: "请选择产品",
                    type: "error",
                });
                return;
            }
            if (!row.engineerId) {
                this.$message({
                    showClose: true,
                    message: "请选择工程师",
                    type: "error",
                });
                return;
            }
            if (row.delivery == null || typeof row.delivery !== 'number') {
                this.$message({
                    showClose: true,
                    message: "请选择是否提货",
                    type: "error",
                });
                return;
            }
            if (!row.overinsuredFlag) {
                this.$message({
                    showClose: true,
                    message: "请选择是否过保",
                    type: "error",
                });
                return;
            }
            updateAfterSalesOrder(row).then((response) => {
                if (response.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    this.closeVisibleAfterSales();
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error",
                    });
                }
            });
        },
        afterSaslesEdit(row, index) {
            this.dialogVisibleAfterSales = true;
            this.goods = {};
            this.engineer = {};
            this.rowData = {
                ...row,
                overinsuredFlag: this.normalizeOverinsuredFlag(row.overinsuredFlag),
            };
            this.index = index;
            getAfterSalesOrder(row.declarationId).then((res) => {
                let data = JSON.parse(res.data).rows[0];
                if (data.type == "ENGINEERING" || data.type == "WATERPROOF") {
                    this.isShowGoods = false;
                } else {
                    this.fetchGoodsList(data.list)
                }
            });
        },
        // 是否过保字段映射：兼容历史 YES/NO 与新值 是/否
        normalizeOverinsuredFlag(val) {
            if (val === 'YES') return '是';
            if (val === 'NO') return '否';
            return val;
        },
        fetchGoodsList(selectedGoods) {
            this.isShowGoods = true;
            findPureWaterGoodsByRootDepartId('PURE_WATER').then(res => {
                if (res.code === "200") {
                    this.goodsList = JSON.parse(res.data).filter(item => selectedGoods.map(item => item.goodsId).includes(item.id));
                    // 
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        toViewOrder(id, row) {
            this.orderId = id;
            this.declarationInfo = row;
            this.viewOrderVisible = true;
            this.viewOrderVisible = true;
            this.evaluateInfo = false;
            this.declarationInfo = row;
            this.orderId = id;
        },
        handleWarehouseList() {
            getWarehouseList().then((res) => {
                let data = JSON.parse(res.data);
                this.warehouseList = data.rows;
            });
        },
        evaluateInfoView(id, type) {
            this.viewOrderVisible = true;
            this.orderId = id;
            this.orderType = type;
            this.evaluateInfo = true;
        },
        viewVideo(url) {
            this.dialogVisibleVideo = true;
            this.nowVideoUrl = url;
        },
        handleEngineerChange(val) {
            // 
            if (this.users.length > 0) {
                // 
                this.user = this.users.find((item) => item.id == val);
                this.engineer = {
                    engineerId: this.user.id,
                    engineerMobile: this.user.mobile,
                    engineerName: this.user.realName,
                }
            }
        },
        /**
         * 
         * @param query 
         * @description 远程搜索工程师
         */
        handleRemote(query) {
            // eslint-disable-next-line no-control-regex
            if (/[^\x00-\xff]/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            } else if (/^\d{8,}$/.test(query)) {
                this.users = [];
                setTimeout(() => {
                    let params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };
                    findUserList(params).then((res) => {
                        if (res.code == "200") {
                            let data = JSON.parse(res.data);
                            this.users = data
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                }, 200);
            }
        },
        formmaterImage(row) {
            let str = new Array();
            JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        openPay(row) {
            this.payRow = row;
            findBalance().then((res) => {
                let data = JSON.parse(res.data);
                this.getBalance = data.rows[0].balance;
                let wxPay = row.promotionCost;
                // let wxPay = 1111111;
                this.noMoney = wxPay > this.getBalance;
                this.dialogBalancePay = true;
            });
        },
        clean() {
            this.describeImgs = [];
            this.remittanceImgs = [];
            this.rechargeMoney = "";
            this.paymentTask = {};
            this.remittanceAccountName = "";
            this.remittanceAccount = "";
            this.currBank = "";
        },
        balancePayment() {
            let params = {};
            params.money = this.rechargeMoney;
            params.rechargeType = "BALANCE";
            params.payType = this.payRadio;
            params.openingUser = this.remittanceAccountName;
            params.bankNumber = this.remittanceAccount;
            params.bankName = this.currBank;
            params.url = this.remittanceImgs + "";
            if (params.payType == "OFFLINE_REMIT") {
                if (
                    params.money &&
                    params.openingUser &&
                    params.bankNumber &&
                    params.bankName &&
                    params.url
                ) {
                    addBalance(params).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message:
                                    "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                                type: "success",
                            });
                            this.rechargeDialog = false;
                            this.payMoneyDialog = false;
                            this.dialogBalancePay = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: "请完善输入信息",
                        type: "error",
                    });
                }
            } else {
                addBalance(params).then((response) => {
                    this.tableLoading = false;
                    if (response.code == "200") {
                        let data = response.data;
                        let count = 0;
                        wxNativePayQuery(data.outTradeNo).then((res) => {
                            if (res.code == "200") {
                                if (res.data == "SUCCESS") {
                                    let _this = this;
                                    setTimeout(function () {
                                        _this.QRCodeDialog = false;
                                        _this.$message({
                                            showClose: true,
                                            message: "充值成功",
                                            type: "success",
                                        });
                                        _this.handleList();
                                        _this.payMoneyDialog = false;
                                        _this.rechargeDialog = false;
                                        _this.dialogBalancePay = false;
                                    }, 1000);
                                } else {
                                    count++;
                                    if (count < 3) {
                                        wxNativePayQuery(data.outTradeNo).then((res) => {
                                            if (res.code == "200") {
                                                if (res.data == "SUCCESS") {
                                                    let _this = this;
                                                    setTimeout(function () {
                                                        _this.QRCodeDialog = false;
                                                        _this.$message({
                                                            showClose: true,
                                                            message: "充值成功",
                                                            type: "success",
                                                        });
                                                        _this.handleList();
                                                        _this.payMoneyDialog = false;
                                                        _this.rechargeDialog = false;
                                                        _this.dialogBalancePay = false;
                                                    }, 1000);
                                                } else {
                                                    this.QRCodeDialog = false;
                                                    this.rechargeDialog = false;
                                                    this.dialogBalancePay = false;
                                                    this.$message({
                                                        showClose: true,
                                                        message: "支付超时",
                                                        type: "error",
                                                    });
                                                }
                                            } else {
                                                this.QRCodeDialog = false;
                                                this.rechargeDialog = false;
                                                this.dialogBalancePay = false;
                                                this.$message({
                                                    showClose: true,
                                                    message: "支付超时",
                                                    type: "error",
                                                });
                                            }
                                        });
                                    }
                                }
                                //this.handleList();
                            } else {
                                this.QRCodeDialog = false;
                                this.$message({
                                    showClose: true,
                                    message: "支付失败",
                                    type: "error",
                                });
                                this.handleList();
                            }
                        });
                        let start = new Date().getTime();
                        // eslint-disable-next-line no-constant-condition
                        while (true) if (new Date().getTime() - start > 1) break;
                        this.config.value = "";
                        this.config.value = data.codeUrl;
                        this.QRCodeDialog = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: "支付失败",
                            type: "error",
                        });
                        //???下面的感觉没用
                        // this.$refs.crud.rowAdd();
                        return;
                    }
                    // let data = JSON.parse(res.data);
                });
            }
        },
        rechargeWayBALANCE() {
            this.paymentTask.rechargeWay = "BALANCE";
        },
        rechargeWayWX_PAY() {
            this.paymentTask.rechargeWay = "WX_PAY";
        },
        rechargeWayOFFLINE_REMIT() {
            this.paymentTask.rechargeWay = "OFFLINE_REMIT";
        },
        toPayMoney() {
            this.clean();
            this.rechargeDialog = true;
        },
        async fnUploadremittanceImgs(option) {
            this.tableLoading = true;
            getAliyunPublicToken().then((res) => {
                let data = JSON.parse(res.data);
                let client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                const storeAs = md5(option.file.name) + new Date().getTime();
                client
                    .multipartUpload(storeAs, option.file, {})
                    .then((results) => {
                        let res = results.res.requestUrls;
                        let files = new Array();
                        for (let url in res) {
                            let file = new Object();
                            file.label = storeAs;
                            file.value = url;
                            files.push(file);
                        }
                        this.fileList1 = files;
                        let array = results.res.requestUrls[0].split("?");
                        this.remittanceImgs.push(array[0]);
                        this.tableLoading = false;
                    })
                    .catch((err) => {
                    });
            });
        },
        closeQRCodeDialog() {
            this.QRCodeDialog = false;
            this.handleList();
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            (params.page = this.page.currentPage), (params.size = pageSize);
            params.type = 'AFTER_SALES';
            findpreAfterSalesOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize,
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            params.type = 'AFTER_SALES';
            findpreAfterSalesOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            // 确认 params.startTime 和 params.endTime 是有效的 Date 对象
            if (params.startTime instanceof Date) {
                params.startTime = params.startTime.getTime();
            }
            if (params.endTime instanceof Date) {
                params.endTime = params.endTime.getTime();
            }
            this.downloadData = params;
            params.type = 'AFTER_SALES';
            findpreAfterSalesOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size,
                };
                this.tableLoading = false;
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            params.type = 'AFTER_SALES';
            findpreAfterSalesOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize,
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.$refs.crud.rowAdd();
        },
        handleGoodsChange(val) {
            if (this.goodsList.length > 0) {
                this.goods = this.goodsList.find(item => item.id == val);
            }
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done, loading) {
            // 
            if (this.engineer) {
                row.engineerId = this.engineer.engineerId;
                row.engineerMobile = this.engineer.engineerMobile;
                row.engineerName = this.engineer.engineerName;
            }
            // 表单验证
            if (!row.goodsId) {
                this.$message({
                    showClose: true,
                    message: "请选择产品",
                    type: "error",
                });
                loading();
                return;
            }
            if (!row.engineerId) {
                this.$message({
                    showClose: true,
                    message: "请选择工程师",
                    type: "error",
                });
                loading();
                return;
            }
            // 校验是否提货
            if (row.delivery == null || typeof row.delivery !== 'number') {
                this.$message({
                    showClose: true,
                    message: "请选择是否提货",
                    type: "error",
                });
                loading();
                return;
            }
            updateAfterSalesOrder(row).then((response) => {
                // 
                if (response.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    done();
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error",
                    });
                    done();
                }
            });
        },
        /**
         * @title 通过
         * @param row 为当前的数据
         */
        handleStatusAudit(row) {
            // 通过(status:TO_EVALUATE)/拒绝(status:IN_SERVICE)
            if (row.status == 'TO_BE_THE_FINAL') {
                this.$confirm('是否通过审核？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '拒绝',
                    type: 'warning'
                }).then(() => {
                    row.status = 'TO_BE_EVALUATED';
                    updateAfterSalesOrder(row).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        showClose: true,
                        message: "操作取消",
                        type: "info",
                    });
                });
            }
        },
        /**
         * @title 拒绝
         * @param row 为当前的数据
         */
        handleStatusRefuse(row) {
            // 通过(status:TO_EVALUATE)/拒绝(status:IN_SERVICE)
            if (row.status == 'TO_BE_THE_FINAL') {
                // 输入拒绝原因
                this.$prompt('请输入拒绝原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^.{1,255}$/,
                    inputErrorMessage: '请输入正确长度的拒绝原因1-255',
                }).then(({ value }) => {
                    row.status = 'IN_SERVICE';
                    row.reason = value;
                    updateAfterSalesOrder(row).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        showClose: true,
                        message: "操作取消",
                        type: "info",
                    });
                });
            }
        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                type: 'AFTER_SALES',
            };
            findpreAfterSalesOrder(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                console.log(this.tableData)
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                };
                getRootDepartmentId().then(res => {
                    let data = res.data;
                    this.rootDepartmentId = data;
                });
                this.tableLoading = false;
            });
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave() { },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
            // this.tableRow = val;
            // this.$notify({
            //     showClose: true,
            //     message: JSON.stringify(val),
            //     type: 'success',
            // });
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel() { },
        refunded(id) {
            this.$prompt("请输入退回原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {};
                    data.id = id;
                    data.returnReason = value;
                    refund(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "提交出错",
                        type: "error",
                    });
                });
        },
        // 查看详情toView
        toView(id) {
            let obj = {
                value: "/work/engineeringProject/engineer/engineerDetails",
                label: "服务清单详情",
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: { GoodsId: id }
            });
        },
        downloadExcel() {
            let params = this.downloadData;
            downloadExcelPureWaterGoods(params).then((response) => {
                // 提取文件名
                const filename = response.headers["content-disposition"].match(
                    /filename=(.*)/
                )[1];
                // 将二进制流转为blob
                const blob = new Blob([response.data], {
                    type: "application/octet-stream",
                });
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                    window.navigator.msSaveBlob(blob, decodeURI(filename));
                } else {
                    // 创建新的URL并指向File对象或者Blob对象的地址
                    const blobURL = window.URL.createObjectURL(blob);
                    // 创建a标签，用于跳转至下载链接
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", decodeURI(filename));
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    // 释放blob URL地址
                    window.URL.revokeObjectURL(blobURL);
                    this.searchChange(params);
                }
            });
        },
        // 生成商家码并显示弹窗
        downloadCode() {
            this.$confirm("是否确认生成通用码?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                const data = {
                    scene: this.rootDepartmentId,
                    page: "pages/afterSales/declaration/declaration",
                    width: "340",
                    clientType: "JOINS_USER",
                };
                getDownloadCode(data).then((response) => {
                    // 提取文件名
                    const filename = response.headers["content-disposition"].match(
                        /filename=(.*)/
                    )[1];
                    // 将二进制流转为blob
                    const blob = new Blob([response.data], {
                        type: "application/octet-stream",
                    });
                    if (typeof window.navigator.msSaveBlob !== "undefined") {
                        // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                        window.navigator.msSaveBlob(blob, decodeURI(filename));
                    } else {
                        // 创建新的URL并指向File对象或者Blob对象的地址
                        const blobURL = window.URL.createObjectURL(blob);
                        // 创建a标签，用于跳转至下载链接
                        const tempLink = document.createElement("a");
                        tempLink.style.display = "none";
                        tempLink.href = blobURL;
                        tempLink.setAttribute("download", decodeURI(filename));
                        // 兼容：某些浏览器不支持HTML5的download属性
                        if (typeof tempLink.download === "undefined") {
                            tempLink.setAttribute("target", "_blank");
                        }
                        // 挂载a标签
                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                        // 释放blob URL地址
                        window.URL.revokeObjectURL(blobURL);
                        this.handleList();
                    }
                });
            })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消生成通用码"
                    });
                });
        },
    },
};
</script>
<style lang="scss">
.remittanceButton {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}
.remittance {
    .recharge {
        margin-top: 10px;
    }
}
.table-container {
    padding: 8px 10px;
}
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
